/**
 * Layout principal de la aplicación
 * Incluye header con selector de sucursal y sidebar de navegación
 * Completamente responsive con drawer en móvil
 */
import React, { useState, useEffect } from "react";
import { Layout, Menu, Drawer } from "antd";
import {
  DashboardOutlined,
  ShopOutlined,
  ExperimentOutlined,
  FileTextOutlined,
  TagOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "./Header";
import BrandHeader from "./BrandHeader";

const { Sider, Content } = Layout;

const MainLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detectar si es móvil
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const menuItems = [
    {
      key: "/",
      icon: <DashboardOutlined />,
      label: "Dashboard",
    },
    {
      key: "/branches",
      icon: <ShopOutlined />,
      label: "Sucursales",
    },
    {
      key: "/ingredients",
      icon: <ExperimentOutlined />,
      label: "Ingredientes Nutricionales",
    },
    {
      key: "/recipes",
      icon: <FileTextOutlined />,
      label: "Recetas",
    },
    {
      key: "/labels",
      icon: <TagOutlined />,
      label: "Etiquetas Nutricionales",
    },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
    if (isMobile) {
      setDrawerOpen(false); // Cerrar drawer en móvil al hacer clic
    }
  };

  const SidebarContent = () => (
    <>
      <BrandHeader />
      <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
          style={{ 
            borderRight: 0, 
            paddingTop: 8,
            fontSize: 14,
            fontWeight: 500,
          }}
        />
      </div>
    </>
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar: Desktop fijo, Mobile como Drawer */}
      {isMobile ? (
        <Drawer
          placement="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          bodyStyle={{ padding: 0 }}
          title={null}
          closable={true}
          width={280}
          style={{ zIndex: 1001 }}
        >
          <SidebarContent />
        </Drawer>
      ) : (
        <Sider
          width={260}
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            background: "#fff",
            boxShadow: "2px 0 8px rgba(0,0,0,0.08)",
            display: "flex",
            flexDirection: "column",
            zIndex: 100,
            overflow: "hidden",
          }}
        >
          <SidebarContent />
        </Sider>
      )}

      <Layout
        style={{
          marginLeft: isMobile ? 0 : 260,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Header onMenuClick={() => setDrawerOpen(true)} showMenuButton={isMobile} />
        <Content
          style={{
            marginTop: isMobile ? 64 : 88,
            marginLeft: isMobile ? "12px" : "24px",
            marginRight: isMobile ? "12px" : "24px",
            marginBottom: isMobile ? "12px" : "24px",
            padding: isMobile ? "16px" : "24px",
            background: "#fff",
            borderRadius: isMobile ? 8 : 12,
            minHeight: isMobile ? "calc(100vh - 76px)" : "calc(100vh - 112px)",
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            overflow: "auto",
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;

